//firebase.js
import Vue from "vue";
import firebase from "firebase/app";
import "firebase/messaging";

const firebaseConfig = {
  apiKey: "AIzaSyBMo0CLd70qJ4qCNcZw9O7ckLlG9y3fevI",
  authDomain: "printable-56c24.firebaseapp.com",
  projectId: "printable-56c24",
  storageBucket: "printable-56c24.firebasestorage.app",
  messagingSenderId: "720227857700",
  appId: "1:720227857700:web:5193d73e8f0a144ffbafb1",
  measurementId: "G-J53CM9EQF0"
};

firebase.initializeApp(firebaseConfig);

export default firebase.messaging();
